import React, {Component} from 'react';
import {connect} from 'react-redux';
import {keyBy} from 'lodash';
import {Button} from 'semantic-ui-react';
import {stockAdjustmentStates} from '../../../common/dictionaries/parameters';
import {Actions} from '../../../common/actions';
import ExcelReader from '../../../excelReader/components/index';
import DeleteModal from './deleteModal';

const submitType = {
  'create': 'CREATE',
  'send': 'SEND',
  'remove': 'REMOVE',
  'approve': 'APPROVE',
  'reject': 'REJECT',
};

class StockAdjustmentFormButtons extends Component {
  constructor(props) {
    super(props);
    this.clearForm = this.clearForm.bind(this);
    this.loadFile = this.loadFile.bind(this);
  }

  formatTransferDetail(data) {
    return data.map((item) => ({'partCode': item[0], 'quantity': item[1]}));
  }

  handleModalDelete(deleteType) {
    const {code, jdeType} = this.props;

    if (deleteType === submitType.remove) {
      this.props.updateStockAdjustmentState(
        code,
        jdeType,
        stockAdjustmentStates.removed
      );
      return;
    }
    this.props.updateStockAdjustmentState(
      code,
      jdeType,
      stockAdjustmentStates.rejected
    );
  }

  clearForm() {
    this.props.clearAdjustmentInfo();
  }

  loadFile(data) {
    const {
      warehouse,
      reason,
      reasonDescription,
      adjustmentType,
      jdeType,
      description,
    } = this.props;

    const detail = this.formatTransferDetail(data);
    this.props.processStockAdjustment({
      warehouse,
      reason,
      reasonDescription,
      adjustmentType,
      jdeType,
      description,
      detail,
    });
  }

  renderRejectButton() {
    const {code, action, state, loading} = this.props;
    if (
      code &&
      (action === 'nuevo' || action === 'editar') &&
      state === stockAdjustmentStates.enter
    ) {
      return (
        <DeleteModal
          trigger={<Button type='button' primary disabled={loading}>Eliminar</Button>}
          isOpen={true}
          title='eliminar la solicitud'
          deleteFunction={() => this.handleModalDelete(submitType.remove)}
        />
      );
    }
    if (code && action === 'aprobar' && state === stockAdjustmentStates.sent) {
      return (
        <DeleteModal
          trigger={<Button type='button' primary disabled={loading}>Rechazar</Button>}
          isOpen={true}
          title='rechazar la solicitud'
          deleteFunction={() => this.handleModalDelete(submitType.reject)}
        />
      );
    }
    return null;
  }

  renderMainButton() {
    const {
      action,
      code,
      warehouse,
      reason,
      description,
      state,
      changeTypeOfSubmit,
      loading,
    } = this.props;
    if (!code) {
      return (
        <Button
          primary
          type='submit'
          onClick={() => changeTypeOfSubmit(submitType.create)}
          disabled={!(warehouse && reason && description)}
        >
          Crear
        </Button>
      );
    }
    if (
      code &&
      (action === 'nuevo' || action === 'editar') &&
      state === stockAdjustmentStates.enter
    ) {
      return (
        <Button
          primary
          type='submit'
          onClick={() => changeTypeOfSubmit(submitType.send)}
          disabled={loading}
        >
          Enviar
        </Button>
      );
    }
    if (code && action === 'aprobar' && state === stockAdjustmentStates.sent) {
      return (
        <Button
          primary
          type='submit'
          onClick={() => changeTypeOfSubmit(submitType.approve)}
          disabled={loading}
        >
          Aprobar
        </Button>
      );
    }
    return null;
  }

  renderClearButton() {
    const {code, warehouse, reason, description} = this.props;
    if (code) {
      return null;
    }
    return (
      <Button
        secondary
        type='button'
        onClick={this.clearForm}
        disabled={!warehouse && !reason && !description}
      >
        Limpiar
      </Button>
    );
  }

  renderExcelImportButton() {
    const {warehouse, reason, description, code} = this.props;
    if (!code) {
      return (
        <ExcelReader
          onGetFile={this.loadFile}
          text='Importar'
          disabled={!(warehouse && reason && description)}
        />
      );
    }

    return null;
  }

  render() {
    return (
      <div className='title-bar-actions'>
        {this.renderExcelImportButton()}
        {this.renderClearButton()}
        {this.renderMainButton()}
        {this.renderRejectButton()}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const {values} = state.form.stockAdjustment;
  const {code, warehouse, reason,
    reasonDescription,
    adjustmentType,
    jdeType,
    description,
  } = values || {};

  const optionsObject = keyBy(state.stockAdjustmentsListDescription.list, 'id');
  const descriptionDefault = optionsObject[description] ?
    optionsObject[description].description :
    description;

  return {
    'loadingFile': state.excelReader.loading,
    'description': descriptionDefault,
    'state': values.state,
    code,
    warehouse,
    reason,
    reasonDescription,
    adjustmentType,
    jdeType,
  };
};

const {
  clearAdjustmentInfo,
  processStockAdjustment,
  updateStockAdjustmentState,
} = Actions;

export default connect(mapStateToProps, {
  clearAdjustmentInfo,
  processStockAdjustment,
  updateStockAdjustmentState,
})(StockAdjustmentFormButtons);
